class CarouselItems extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.drag = { x: 0, y: 0 };

    this.addEventListener('touchstart', debounce(this.onDragChanged.bind(this), 500), { passive: true });
    this.addEventListener('touchend', debounce(this.onDragChanged.bind(this), 500), { passive: true });
    this.addEventListener('mouseenter', debounce(this.stopInterval.bind(this), 500), { passive: true });
    this.addEventListener('mouseover', debounce(this.stopInterval.bind(this), 500), { passive: true });
    this.addEventListener('mouseleave', debounce(this.startInterval.bind(this), 500), { passive: true });

    this.elements = {
      indicator: this.querySelector("[id^=Carousel_Indication_]"),
      switcher: this.querySelector("[id^=Carousel_Switchers_]"),
      scrollHolder: this.querySelector("[id^=Carousel_Scroll_holder_]")
    };

    if (this.elements?.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[this.index]) {
      this.elements.scrollHolder.querySelectorAll(".ml_carousel_item")[this.index].querySelectorAll("a, button").forEach(el => {
        el.tabIndex = 0;
      });
    }

    this.length = this.elements.indicator?.querySelectorAll("li")?.length;
    if (this.elements.scrollHolder?.querySelectorAll(".ml_carousel_item")?.length > 0) {
      this.startInterval();
    }

    const that = this;
    this.elements.indicator?.querySelectorAll("li")?.forEach(el => {
      el.addEventListener("click", () => that.specificItem(el.dataset.index), { passive: true });
      el.onkeypress = e => { if (e.key === "Enter") el.click(); };
    });

    this.elements.switcher?.querySelector(`#next_${this.dataset.sectionId}`)?.addEventListener("click", () => {
      that.nextItem();
    }, { passive: true });

    this.elements.switcher?.querySelector(`#previous_${this.dataset.sectionId}`)?.addEventListener("click", () => {
      that.prevItem();
    }, { passive: true });
  }

  startInterval() {
    if (this.dataset.slideshow == 'true' && this.dataset.interval) {
      this.interval = setInterval(() => this.nextItem(), this.dataset.interval * 1000);
    }
  }

  stopInterval() {
    clearInterval(this.interval);
  }

  restartInterval() {
    this.stopInterval();
    this.startInterval();
  }

  onDragChanged(event) {
    if (event.type == 'touchstart') {
      this.drag = { x: event.x, y: event.y };
    } else {
      if (this.drag.x != event.x) {
        if ((this.drag.x - event.x) < 0) {
          this.prevItem();
        } else {
          this.nextItem();
        }
      }
    }
  }

  nextItem() {
    const oldIndex = this.index;
    this.index = (this.index + 1) % this.length;
    this.handleChange(oldIndex);
  }

  prevItem() {
    const oldIndex = this.index;
    this.index = this.index - 1 < 0 ? this.length - 1 : this.index - 1;
    this.handleChange(oldIndex);
  }

  specificItem(index) {
    const oldIndex = this.index;
    this.index = parseInt(index);
    this.handleChange(oldIndex);
  }

  handleChange(oldIndex = 0) {
    if (this.elements?.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[oldIndex]) {
      this.elements.scrollHolder.querySelectorAll(".ml_carousel_item")[oldIndex].querySelectorAll("a, button").forEach(el => {
        el.tabIndex = -1;
      });
    }

    const selectedItem = this.elements.scrollHolder?.querySelectorAll(".ml_carousel_item")?.[this.index];
    selectedItem?.querySelectorAll("a, button").forEach(el => el.tabIndex = 0);

    // Animate items (optional)
    ["ml_product_info", "ml_carousel_title", "ml_carousel_actions"].forEach(cls => {
      const el = selectedItem?.querySelector(`.${cls}`);
      if (el) {
        el.classList.remove("ml_animate_left");
        setTimeout(() => el.classList.add("ml_animate_left"), 0);
      }
    });

    const img = selectedItem?.querySelector(".ml_img_holder");
    if (img) {
      img.classList.remove("ml_animate_right");
      setTimeout(() => img.classList.add("ml_animate_right"), 0);
    }

    // TRANSLATE X MOVEMENT (crucial part)
    setTimeout(() => {
      this.elements.scrollHolder.style.transform = `translateX(-${this.index * 100}%)`;
    }, 0);

    this.elements.indicator?.querySelectorAll("li")?.forEach(el => el.classList.remove("active"));
    this.elements.indicator?.querySelectorAll("li")?.[this.index].classList.add("active");

    if (this.interval) {
      this.restartInterval();
    }
  }
}
customElements.define('carousel-item', CarouselItems);